import React from 'react';

export const DownArrowIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M0.5 0.5L4.5 4.5L8.5 0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);